import { ApiService } from '@shared/api';

class SettingsService extends ApiService {
  // eslint-disable-next-line
  constructor(props) {
    super(props);

    this.baseUrl = '/settings'; 
    this.subscribeUrl = '/subscribes';
  }

  async getSettings() {
    return await this.instance.get(this.baseUrl);
  }

  async getReviews() {
    return await this.instance.get('/reviews');
  }

  async getAllSubscribes() {
    return await this.instance.get(this.subscribeUrl);
  }

  async getAllSubscribesAdmin() {
    return await this.instance.get(`${this.subscribeUrl}/settings`);
  }

  async updateSubscribes(formData) {
    this.setFormDataInterceptors();

    return await this.instance.put(`${this.subscribeUrl}/update`, formData)
  }

  setFormDataInterceptors() {
    this.instance.interceptors.request.use((config) => {
      config.headers['Content-Type'] = 'multipart/form-data';
      config.headers['Accept'] = 'multipart/form-data';

      return config;
    });
  }
}

const settingService = new SettingsService();

export default settingService;
